import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { createElement } from 'react';
import isSize from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';
import CheckRadioControl from './CheckRadioControl';
import styles from './FormField.module.scss';
import SelectControl from './SelectControl';
import TextareaControl from './TextareaControl';
import TextualControl from './TextualControl';
import ToggleControl from './ToggleControl';

const propTypes = {
  className: PropTypes.string,
  component: PropTypes.elementType,
  error: PropTypes.string,
  helpText: PropTypes.node,
  inlineError: PropTypes.bool,
  label: PropTypes.node,
  toggle: PropTypes.bool,
  type: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'compact', 'small', 'normal']),
  name: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

const defaultProps = {
  className: null,
  component: null,
  error: null,
  helpText: null,
  inlineError: false,
  label: null,
  toggle: undefined,
  type: 'text',
  margin: undefined,
  name: undefined,
  onChange: undefined,
  checked: undefined,
};

const getMargin = ({ margin, type }) =>
  margin || (['radio', 'checkbox'].includes(type) ? 'compact' : 'normal');

const FormField = (props) => {
  const {
    className,
    component,
    helpText,
    toggle,
    error,
    inlineError: preferInlineError,
    ...childProps
  } = props;
  const { type } = props;
  const marginClass = {
    normal: styles.marginNormal,
    small: styles.marginSmall,
    compact: styles.marginCompact,
  }[getMargin(props)];

  const classes = classNames(
    className,
    styles.formField,
    !component && styles[props.type],
    marginClass,
  );

  const commonProps = {
    error,
    ...childProps,
  };

  const inlineError = preferInlineError && !isSize(Sizes.SM);

  let control;
  if (component) {
    control = createElement(component, commonProps);
  } else if (type === 'checkbox' && toggle) {
    control = <ToggleControl {...commonProps} />;
  } else if (type === 'checkbox' || type === 'radio') {
    control = <CheckRadioControl {...commonProps} />;
  } else if (type === 'select') {
    control = <SelectControl {...commonProps} />;
  } else if (type === 'textarea') {
    control = <TextareaControl {...commonProps} />;
  } else {
    control = <TextualControl inlineError={inlineError} {...commonProps} />;
  }

  return (
    <div className={classes}>
      {control}
      {!inlineError && error && (
        <div className={styles.errorMessage}>{error}</div>
      )}
      {helpText && <div className={styles.helpText}>{helpText}</div>}
    </div>
  );
};

FormField.propTypes = propTypes;
FormField.defaultProps = defaultProps;

export default FormField;
